import { FC, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import useUser from "@hooks/use-user";
import { Loader } from "@components/loader";
import { PermissionsProvider } from "@contexts/permissions.context";
import { TimezoneProvider } from "@contexts/timezone.context";
import posthog from "posthog-js";

const PrivateLayout: FC = () => {
  const { user, loading } = useUser();
  const { pathname } = useLocation();

  useEffect(() => {
    if (user?.sub && user?.["custom:companyId"]) {
      posthog.identify(user.sub, {
        organizationId: user["custom:companyId"] as string,
      });
    }
  }, [user]);

  if (loading) {
    return <Loader />;
  }

  if (!user) {
    localStorage.setItem("ul_redirect_path", pathname);
    return <Navigate to="/auth/signin" replace />;
  }

  return (
    <TimezoneProvider>
      <PermissionsProvider>
        <Outlet context={user} />
      </PermissionsProvider>
    </TimezoneProvider>
  );
};

export default PrivateLayout;
